(() => {
  const configNode = document.querySelector('[data-fashion-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent), quick = document.querySelector('[data-quick-dialog]');
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  let busy = false, quickRecord, opener;
  const money = value => new Intl.NumberFormat(config.locale, {style: 'currency', currency: config.currency}).format(value / 100);
  const open = dialog => { if (!dialog || dialog.open) return; opener = document.activeElement; dialog.showModal(); document.documentElement.classList.add('fq-dialog-open'); };
  function close(dialog) { dialog.close(); if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('fq-dialog-open'); if (opener?.isConnected) opener.focus({preventScroll: true}); }
  function setupDialog(dialog) {
    if (dialog.dataset.fashionReady) return;
    dialog.dataset.fashionReady = 'true';
    dialog.addEventListener('click', event => { if (event.target === dialog || event.target.closest('[data-close-dialog]')) close(dialog); });
    dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('fq-dialog-open'); });
  }
  document.querySelectorAll('[data-cart-dialog], [data-quick-dialog]').forEach(setupDialog);
  function refreshCart(html) {
    if (!html) { location.assign(config.cart); return; }
    const doc = new DOMParser().parseFromString(html, 'text/html'), incoming = doc.querySelector('[data-fashion-cart-root]'), current = document.querySelector('[data-fashion-cart-root]');
    if (!incoming || !current) { location.assign(config.cart); return; }
    const count = JSON.parse(incoming.querySelector('[data-cart-state]').textContent).count;
    current.replaceWith(incoming);
    const headerRewards = document.querySelector('.eq-rewards--header');
    if (headerRewards) headerRewards.replaceWith(incoming.querySelector('[data-header-rewards]').content.cloneNode(true));
    document.querySelectorAll('.eq-rewards--product').forEach(rewards => rewards.replaceWith(incoming.querySelector('[data-product-rewards]').content.cloneNode(true)));
    document.querySelectorAll('.enriq-header__cart').forEach(link => {
      link.setAttribute('aria-label', config.cartCount.replace('__count__', count));
      let badge = link.querySelector('span');
      if (count > 0) { if (!badge) { badge = document.createElement('span'); link.append(badge); } badge.textContent = count; } else badge?.remove();
    });
    const dialog = incoming.querySelector('[data-cart-dialog]'); setupDialog(dialog);
    if (quick.open) close(quick);
    open(dialog);
  }
  async function add(form) {
    if (busy) return;
    busy = true;
    const submit = form.querySelector('[type="submit"]'), status = form.querySelector('[data-form-status]');
    const label = submit.textContent;
    submit.disabled = true; submit.textContent = config.loading; form.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    try {
      const body = new FormData(form); body.set('sections', 'enriq-cart-drawer'); body.set('sections_url', location.pathname);
      const response = await fetch(`${root}cart/add.js`, {method: 'POST', body, headers: {'Accept': 'application/json'}});
      const result = await response.json();
      if (!response.ok) throw Error(result.description || config.error);
      refreshCart(result.sections?.['enriq-cart-drawer']);
    } catch (error) { if (status) status.textContent = error.message || config.error; }
    finally { busy = false; form.removeAttribute('aria-busy'); submit.disabled = false; submit.textContent = label; }
  }
  document.addEventListener('click', async event => {
    if (event.target.matches('[data-size-option]')) {
      const page = event.target.closest('[data-enriq-product]');
      page.dataset.sizeChosen = 'true';
      const selected = page.querySelector('select[name="id"]')?.selectedOptions[0], button = page.querySelector('[data-sticky-buy]');
      if (selected && button) { button.disabled = selected.dataset.available !== 'true'; button.textContent = button.disabled ? config.sold : config.add; page.querySelector('[data-sticky-price]').textContent = selected.dataset.price; }
    }
    const cartLink = event.target.closest('.enriq-header__cart');
    if (cartLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); open(document.querySelector('[data-cart-dialog]')); }
    const trigger = event.target.closest('[data-quick-shop]');
    if (trigger) {
      const card = trigger.closest('[data-eq-card]'), data = JSON.parse(card.querySelector('[data-card-data]').textContent);
      quickRecord = [data.record, ...data.colors].find(record => String(record.id) === card.dataset.selectedProduct) || data.record;
      const image = quick.querySelector('[data-quick-image]');
      if (quickRecord.images[0]) { image.src = quickRecord.images[0].url; image.alt = quickRecord.images[0].alt; }
      quick.querySelector('[data-quick-title]').textContent = quickRecord.name;
      quick.querySelector('[data-quick-color]').textContent = quickRecord.color || '';
      quick.querySelector('[data-quick-price]').textContent = money(quickRecord.price);
      quick.querySelector('[data-quick-link]').href = quickRecord.url;
      const sizes = quick.querySelector('[data-quick-sizes]');
      sizes.querySelectorAll('label').forEach(label => label.remove());
      quick.querySelector('[data-quick-variant]').value = '';
      const submit = quick.querySelector('[data-quick-submit]'); submit.disabled = true; submit.textContent = config.choose;
      quick.querySelector('[data-form-status]').textContent = '';
      quickRecord.variants.forEach(variant => {
        const label = document.createElement('label'); label.className = 'eq-size';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'quick_size'; radio.value = variant.id; radio.disabled = !variant.available; radio.required = true;
        const text = document.createElement('span'); text.textContent = variant.title;
        label.append(radio, text); sizes.append(label);
      });
      open(quick);
    }
    const change = event.target.closest('[data-cart-key]');
    if (change && !busy) {
      busy = true;
      const dialog = change.closest('[data-cart-dialog]'); dialog.setAttribute('aria-busy', 'true');
      dialog.querySelectorAll('[data-cart-key],button[name="checkout"]').forEach(button => button.disabled = true);
      try {
        const response = await fetch(`${root}cart/change.js`, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({id: change.dataset.cartKey, quantity: Number(change.dataset.cartQuantity), sections: ['enriq-cart-drawer'], sections_url: location.pathname})});
        const result = await response.json();
        if (!response.ok) throw Error(result.description || config.error);
        refreshCart(result.sections?.['enriq-cart-drawer']);
      } catch (error) { dialog.querySelector('[data-cart-status]').textContent = error.message || config.error; }
      finally { busy = false; dialog.removeAttribute('aria-busy'); dialog.querySelectorAll('[data-cart-key],button[name="checkout"]').forEach(button => button.disabled = false); }
    }
    if (event.target.closest('[data-sticky-buy]')) {
      const page = event.target.closest('[data-enriq-product]'), form = page.querySelector('.eq-product__form');
      if (page.dataset.sizeChosen === 'true' || !page.querySelector('[data-size-option]')) form.requestSubmit();
      else { form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'}); page.querySelector('[data-size-option]:not(:disabled)')?.focus({preventScroll: true}); }
    }
  });
  quick.addEventListener('change', event => {
    if (!event.target.matches('[name="quick_size"]')) return;
    const variant = quickRecord.variants.find(v => String(v.id) === event.target.value);
    quick.querySelector('[data-quick-variant]').value = variant.id;
    quick.querySelector('[data-quick-price]').textContent = money(variant.price);
    const submit = quick.querySelector('[data-quick-submit]'); submit.disabled = !variant.available; submit.textContent = variant.available ? config.add : config.sold;
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.eq-product__form, [data-quick-form]')) { event.preventDefault(); if (event.target.reportValidity()) add(event.target); }
  });
  document.addEventListener('change', event => {
    const page = event.target.closest('[data-enriq-product]');
    if (!page || !event.target.matches('[data-size-option], select[name="id"]')) return;
    page.dataset.sizeChosen = 'true';
    const selected = page.querySelector('select[name="id"]')?.selectedOptions[0], button = page.querySelector('[data-sticky-buy]');
    if (selected && button) { button.disabled = selected.dataset.available !== 'true'; button.textContent = button.disabled ? config.sold : config.add; page.querySelector('[data-sticky-price]').textContent = selected.dataset.price; }
  });
  document.querySelectorAll('[data-enriq-product]').forEach(page => {
    const bar = page.querySelector('[data-sticky-bar]'), purchase = page.querySelector('.eq-product__purchase');
    if (!bar || !purchase) return;
    const observer = new IntersectionObserver(entries => { bar.classList.toggle('is-visible', !entries[0].isIntersecting); }, {threshold: 0.1}); observer.observe(purchase);
  });
})();
